import { createSelector } from 'reselect';
import { converter } from '../../../helpers/converter';

const translationsStore = store => store.translations;
const assetStore = store => store.asset;
const contentStore = store =>
  typeof store.card.contentData === 'undefined' ||
  store.card.contentData === null
    ? {}
    : store.card.contentData;

export const labelsSelector = createSelector(
  translationsStore,
  contentStore,
  (labels, data = {}) => {
    const {
      extendedcommon = {
        media: {
          proveedor: {},
        },
      },
    } = data;
    return {
      btnLabelAddList: converter.convertApaUnicode(
        labels,
        'btn_add_fav',
        'Por ver',
      ),
      labelOriginalTitle: converter.convertApaUnicode(
        labels,
        'original_title',
        'Título Original',
      ),
      btnLabelShare: converter.convertApaUnicode(
        labels,
        'stb_btn_share',
        'Compartir',
      ),
      btnLabelPlay: converter.convertApaUnicode(
        labels,
        'labels_free_value',
        'Ver',
      ),
      btnLabelTrailer: converter.convertApaUnicode(
        labels,
        'btn_trailer',
        'Ver',
      ),
      labelRecommended: converter.convertApaUnicode(labels, 'recomended'),
      labelNotPlayable:
        converter.convertApaUnicode(
          labels,
          `${
            extendedcommon.media.proveedor.nombre
          }_videoplayer_unsupported_encoder`,
        ) ||
        converter.convertApaUnicode(
          labels,
          'videoplayer_unsupported_encoder',
        ) ||
        'Este contenido no esta disponible para tu navegador por favor intenta con otro.',
      modalDownloadIcon: converter.convertApaUnicode(
        labels,
        'download_notification_icon_image',
        'fa fa-play-circle',
      ),
      modalInfoFirst: converter.convertApaUnicode(
        labels,
        'download_text_app_old_experience',
        'Tus contenidos descargados se mostrarán en nuestra app Centro de Descargas',
      ),
      modalInfoSecond: converter.convertApaUnicode(
        labels,
        'download_text_app_question',
      ),
      modalDownloadApp: converter.convertApaUnicode(
        labels,
        'download_text_no_yet_button',
      ),
      modalInstalledApp: converter.convertApaUnicode(
        labels,
        'download_text_ok_aware_button',
      ),
      modalCancel: converter.convertApaUnicode(
        labels,
        'download_text_cancel_button',
      ),
      modalContinue: converter.convertApaUnicode(
        labels,
        'player_btn_continue_txt',
      ),
      modalBack: converter.convertApaUnicode(labels, 'btn_menu_back'),
      modalPreInfo: `* ${converter.convertApaUnicode(
        labels,
        'brief_dwnlds_pre_info',
      )}`,
      configDownload: {
        btnQuality: converter.convertApaUnicode(
          labels,
          'download_text_quality_dw_button',
        ),
        btnQualityLow: converter.convertApaUnicode(
          labels,
          'download_text_quality_low',
        ),
        btnQualityHigh: converter.convertApaUnicode(
          labels,
          'download_text_quality_high',
        ),
        btnLanguages: converter.convertApaUnicode(
          labels,
          'download_text_languages_dw_button',
        ),
        textConfig: converter.convertApaUnicode(
          labels,
          'download_text_config_dw',
        ),
      },
    };
  },
);

export const assetsSelector = createSelector(
  assetStore,
  (data = {}) => {
    const {
      dw_assets_to_download: srcIconDownload,
      dw_assets_languages: srcIconLanguages,
    } = data;

    return {
      ...data,
      srcIconDownload,
      srcIconLanguages,
    };
  },
);
